import { render, staticRenderFns } from "./wordPreview.vue?vue&type=template&id=54a4dedc&scoped=true&"
import script from "./wordPreview.vue?vue&type=script&lang=js&"
export * from "./wordPreview.vue?vue&type=script&lang=js&"
import style0 from "./wordPreview.vue?vue&type=style&index=0&id=54a4dedc&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4dedc",
  null
  
)

export default component.exports